import React from 'react'
import { Header } from '../wallet/header/header'
import { Footer } from '../Home/Footer'
import { useNavigate } from 'react-router-dom'

//form
import {useForm} from "react-hook-form"
import * as yup from "yup"
import {yupResolver} from "@hookform/resolvers/yup"

//toast
import 'react-toastify/dist/ReactToastify.css'; // import first and after the toastify is work 
import { toast } from 'sonner'
import axios from '../utils/axios'
import useAuth from '../context/hook/useAuth'


export const Support = () => {

  const {user} = useAuth()

  const navigate = useNavigate()

  const schema = yup.object().shape({
    name:yup.string().required(),
    content:yup.string().required(),
    // password:yup.string().min(7).max(20).required(),
    // confirm_password: yup.string().label('confirm password').required().oneOf([yup.ref('password'), null], 'Passwords must match'),
  })

  // eslint-disable-next-line
  const { register, handleSubmit, reset, formState: { errors } } = useForm({
    resolver: yupResolver(schema)
  });

  const onSubmit = async (data,e) => {
    try {
      // console.log("content",data.content)
      // console.log("name",data.name)
      await axios.post("/support",
        {
          content:data.content,
          list:data.name,
          // command: 'stop'
        },
        {
          headers:{
              "Content-Type": "application/json",
              "Authorization":user
          },
          withCredentials:true,
        },
      ).then(()=>{
        setTimeout(()=>{
            navigate('/wallet',{replace: true})
        },3000)
        // toast.success("Query has been placed successfully, ",{position:'top-right'})
        toast.success(<div>Query has been placed successfully.<br/>Our Customer Services team will get back to you within next 24 hours.</div>,{enableHtml: true,position:'top-right'})
      }).catch(err=>{
        console.log(err)
        toast.error("Try again later")
      })
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <div>
        <Header />
        
        <section class="feature-section pb-0">
        <div class="container pb-md-5 pb-0">
            <div class="title-basic fs-sm">
              
            </div>
         
            <div class="row g-xxl-5 g-4 justify-content-center support-box">
              <div class="col-lg-5">
                <div class="buy-box ">
                    <div class="buy-head">
                        <h3>Support</h3>
                    </div>
                    <div class="deposit-area">
                        <form action="" >
                            
                              <div class="form-group">
                                <label for="exampleFormControlSelect1">Select Query</label>
                                <select {...register("name")} class="custom-select" required="">
                                  <option value="">Select</option>
                                  <option value="Deposit & Withdrawal Issues">Deposit & Withdrawal Issues</option>
                                  <option value="Buy Token Issues">Buy Token Issues</option>
                                  <option value="Login and Register Issues">Login and Register Issues</option>
                                  <option value="Others">Others</option>
                                </select>
                                {errors.name && <p style={{fontSize:'12px',color:'red'}}>Please Select Query</p>}
                              </div>
                              <div class="form-group">
                                <label for="exampleFormControlTextarea1">Description</label>
                                <textarea {...register("content")} class="form-control" id="exampleFormControlTextarea1" rows="5"></textarea>
                            </div>
                            <div class="qtsYk">
                                 <button  onClick={handleSubmit(onSubmit)}  data-size="large" type="button" class="jRLsY SOUdU" style={{width: "100%", marginTop: "24px"}}>
                                  <span>
                                  SUBMIT
                                  </span>
                                </button>
                                {/* <button> SUBMIT </button> */}
                              </div>
                        </form>
                      
                    </div>

                </div>
              </div>
            </div>
        </div>
    </section>
        
        <Footer />    
    </div>
  )
}
